import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { GridSizeType, getEnvs, gridSizeMdLg12 } from '@/shared';
import { CreateOrCancelButtons, ReporteComponente } from '..';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { useUiStore } from '@/store/ui';
import { AlertSeverityEnum } from '@/shared/interfaces';


const { VITE_API_URL_AWS } = getEnvs();


export type SingleFormBoxSceneProps = {
  children: React.ReactNode;
  titlePage?: string;
  onCancel?: () => void;
  onSave?: (
    e?: React.BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>;
  showActionBtns?: boolean;

  disableSubmitBtn?: boolean;

  formGridSize?: GridSizeType;
  containerMaxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /**
   * Ancho del formulario dentro del contenedor. Por defecto se limita al 70% en
   * desktop; pásalo (p.ej. `{ md: '92%' }`) para formularios anchos con muchas
   * columnas sin afectar al resto de pantallas que usan este layout.
   */
  formWidth?: { xs?: string; sm?: string; md?: string; lg?: string } | string;

  saveTextBtn?: string;
  cancelTextBtn?: string;

  showCustomBtns?: boolean;
  customBtns?: React.ReactNode;

  //importar excel
  enableUploadFile?: boolean;
  fileInputRef?: React.RefObject<HTMLInputElement>;
  handleFileUpload?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  urlDownloadPlantilla?: string;
  urlDownloadNameExcel?: string;
  num_referencia?: string
  additionalNoteText?: React.ReactNode;
  py?: number
};

const SingleFormBoxScene: React.FC<SingleFormBoxSceneProps> = ({
  children,
  titlePage,
  onCancel,
  onSave,
  disableSubmitBtn = false,
  containerMaxWidth = 'lg',
  formWidth = { xs: '100%', sm: '80%', md: '70%' },
  showActionBtns = true,
  saveTextBtn,
  cancelTextBtn,

  showCustomBtns = false,
  customBtns,

  enableUploadFile = false,
  fileInputRef,
  handleFileUpload,
  urlDownloadPlantilla,
  urlDownloadNameExcel = 'plantilla.xlsx',
  num_referencia,
  additionalNoteText,
  py = 4
}) => {

  const downloadExcel = async (url: string, fileName: string) => {
    try {
      const response = await axios.get(url, {
        responseType: 'blob', // Importante para obtener el archivo como un blob
      });

      console.log(response);

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, fileName);
    } catch (error) {
      console.error('Error al descargar el archivo Excel:', error);
    }
  };

  const setAlert = useUiStore(s => s.setAlert);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: py,
      }}
    >
      <Container maxWidth={containerMaxWidth}>
        <Stack spacing={3}>
          {/* ======= title ======= */}

          {
            num_referencia
              ? <Typography variant="h4">
                {`${titlePage} `}
                <span className="cliente__page--subtitle">
                  ({num_referencia})
                </span>
              </Typography>
              :
              <Typography variant="h4">
                {titlePage}
              </Typography>
          }

          {
            enableUploadFile && (
              <ReporteComponente
                fileInputRef={fileInputRef}
                importExcel={handleFileUpload}
                downloadPlantilla={async () => {
                  console.log(`${VITE_API_URL_AWS}${urlDownloadPlantilla}`);

                  try {
                    await downloadExcel(`${VITE_API_URL_AWS}${urlDownloadPlantilla}`!, `${urlDownloadNameExcel}.xlsx`)
                  } catch (error) {
                    setAlert(true, 'Lo sentimos ocurrio un error al descargar la plantilla', AlertSeverityEnum.error);
                  }
                }}
              />
            )
          }

          {
            additionalNoteText &&
            <Grid {...gridSizeMdLg12}>
              {additionalNoteText}
            </Grid>
          }

          {/* ======= form ======= */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'center'
          }}>

            <Grid container
              justifyContent={'space-between'}
              spacing={3}
              alignContent={'center'}
              sx={{
                width: formWidth
              }}
            >
              {children}


              {/* ====== submit btn ====== */}
              {showActionBtns && (
                <CreateOrCancelButtons
                  onCancel={() => onCancel && onCancel()}
                  onSave={() => {
                    if (onSave) onSave()
                  }}
                  disabled={disableSubmitBtn}
                  saveTextBtn={saveTextBtn}
                  cancelTextBtn={cancelTextBtn}
                />
              )}

              {/* ====== custom btns ====== */}
              {showCustomBtns && customBtns}

            </Grid>

          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default SingleFormBoxScene;
